// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2ZFrR","noInteraction":"EventWrapper_noInteraction__T07-V"};